import apiConnector from '@/epersonam/apiConnector';
import errorManager from '@/rollbar.js';

const drawGraph = (gpds, vmd_type, select, chartDiv) => {
  const baseUrl = `${window.config.ePersonamService.ePersonamHost}/${window.locale}`;
  const getSingleTrendUrl = `${baseUrl}/guest_period_data_sets/${gpds}/guest_vmds/${vmd_type}/trend_single_item.json?esas_item=${select.value}`;
  apiConnector()
    .get(getSingleTrendUrl)
    .then((response) => {
      google.charts.load('current', { packages: ['corechart'] });
      google.charts.setOnLoadCallback(() => {
        const rowsWithAnnotations = response.data.data_table.rows.map((row) => {
          const annotation = row[1].v?.toString();
          return [...row, annotation];
        });
        const dataTable = google.visualization.arrayToDataTable([
          ['date', 'points', { type: 'string', role: 'annotation' }],
          ...rowsWithAnnotations,
        ]);
        const chart = new google.visualization.LineChart(chartDiv);
        chart.draw(dataTable, response.data.options);
      });
    });
};

const addMenuSelect = (topChart, dc_select) => {
  const optionsSelectJSON = dc_select.replace(/&quot;/g, '"');
  const optionsSelect = JSON.parse(optionsSelectJSON);
  const optionsSelectHtml = optionsSelect.map((option) => `<option value="${option[0]}">${option[1]}</option>`);
  const labelHtml = `<label class="control-label" for="selectItem">Seleziona voce</label>`;
  const selectHtml = `<select id="selectItem" class="chzn-select2">${optionsSelectHtml.join('')}</select>`;
  const topDiv = document.getElementById(topChart);
  topDiv.insertAdjacentHTML('afterbegin', `<div class="row-fluid">${labelHtml}${selectHtml}</div>`);
};

const singleItemTrend = (chartId, topChartId, gpds, vmd_type, dc_select) => {
  const chartDiv = document.getElementById(chartId);
  addMenuSelect(topChartId, dc_select);
  const select = document.getElementById('selectItem');
  drawGraph(gpds, vmd_type, select, chartDiv);
  select.onchange = () => {
    drawGraph(gpds, vmd_type, select, chartDiv);
  };
};

const init = (chartId, topChartId, gpds, vmd_type, dc_select) => {
  try {
    singleItemTrend(chartId, topChartId, gpds, vmd_type, dc_select);
  } catch (e) {
    errorManager(e);
  }
};

window.GetSingleVmdChart = {
  init: init,
};
